export default __webpack_public_path__ + "efcdeeae50c215a92812f62d799a2b6f.svg";